import { memo } from 'react'
import FlatTabbar from 'common-components/FlatTabbar'
import Aspect169Icon from 'assets/svgr-icons/Aspect_Ratio_16_9_Dropdown.svg'
import Aspect916Icon from 'assets/svgr-icons/Aspect_Ratio_9_16_Dropdown.svg'

import { ASPECT_RATIO_PER_TYPE } from 'containers/SubSidebar/AiImageContent/consts'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import * as Styled from './styled'

interface IProps {
  // The currently selected aspect ratio (e.g. '16:9' | '9:16').
  value: string
  onChange: (ratio: string) => void
}

// Each tab's `name` IS the aspect-ratio value, so `onCurrentItemClick` hands the
// chosen ratio straight back to `onChange`. Tabs are icon-only.
const TAB_DATA = [
  {
    name: ASPECT_RATIO_PER_TYPE.landscape,
    tooltipText: ASPECT_RATIO_PER_TYPE.landscape,
    icon: (
      <Aspect169Icon role="img" aria-label={translate(T.WIDESCREEN_LABEL)} />
    )
  },
  {
    name: ASPECT_RATIO_PER_TYPE.portrait,
    tooltipText: ASPECT_RATIO_PER_TYPE.portrait,
    icon: <Aspect916Icon role="img" aria-label={translate(T.PORTRAIT_LABEL)} />
  }
]

// Landscape/Portrait toggle in the public-avatars panel header. Lets the user
// pick the avatar's aspect ratio independently of the project. Reuses the shared
// `FlatTabbar` segmented control with icon-only tabs.
const AspectRatioToggle: React.FC<IProps> = ({ value, onChange }) => {
  return (
    <Styled.Toggle data-testid="avatar-aspect-ratio-toggle">
      <FlatTabbar
        dataWithTexts={TAB_DATA}
        defaultActiveTabName={value}
        onCurrentItemClick={onChange}
        height={32}
      />
    </Styled.Toggle>
  )
}

export default memo(AspectRatioToggle)
